import Icon from '.';

function createIcon(icon) {
  return defineComponent({
    props: { size: { type: Number, default: 16 } },
    setup(props) {
      return () => <Icon icon={icon} size={props.size}></Icon>;
    },
  });
}
export const SearchOutlined = createIcon('ant-design:search-outlined');

export const InfoCircleOutlined = createIcon('ant-design:info-circle-outlined');

export const CloseOutlined = createIcon('ant-design:close-outlined');

export const FullscreenExitOutlined = createIcon('ant-design:fullscreen-exit-outlined');

export const FullscreenOutlined = createIcon('ant-design:fullscreen-outlined');

export const LoadingOutlined = createIcon('ant-design:loading-outlined');

export const MoreOutlined = createIcon('ant-design:more-outlined');

export const FormOutlined = createIcon('ant-design:form-outlined');

export const LeftOutlined = createIcon('ant-design:left-outlined');

export const RightOutlined = createIcon('ant-design:right-outlined');

export const DownOutlined = createIcon('ant-design:down-outlined');

export const CheckOutlined = createIcon('ant-design:check-outlined');

export const PlusOutlined = createIcon('ant-design:plus-outlined');

export const SettingOutlined = createIcon('ant-design:setting-outlined');

export const EditOutlined = createIcon('ant-design:edit-outlined');

export const DragOutlined = createIcon('ant-design:drag-outlined');

export const ColumnHeightOutlined = createIcon('ant-design:column-height-outlined');

export const ColumnWidthOutlined = createIcon('ant-design:column-width-outlined');

export const RedoOutlined = createIcon('ant-design:redo-outlined');

export const UndoOutlined = createIcon('ant-design:undo-outlined');

export const InfoCircleFilled = createIcon('ant-design:info-circle-filled');

export const CheckCircleFilled = createIcon('ant-design:check-circle-filled');

export const CloseCircleFilled = createIcon('ant-design:close-circle-filled');

export const DoubleRightOutlined = createIcon('ant-design:double-right-outlined');

export const SyncOutlined = createIcon('ant-design:sync-outlined');

export const DeleteOutlined = createIcon('ant-design:delete-outlined');

export const ExclamationCircleOutlined = createIcon('ant-design:exclamation-circle-outlined');

export const SwapOutlined = createIcon('ant-design:swap-outlined');

export const ArrowLeftOutlined = createIcon('ant-design:arrow-left-outlined');

export const VerticalRightOutlined = createIcon('ant-design:vertical-right-outlined');

export const VerticalLeftOutlined = createIcon('ant-design:vertical-left-outlined');

export const EllipsisOutlined = createIcon('ant-design:ellipsis-outlined');

export const TableOutlined = createIcon('ant-design:table-outlined');

export const InboxOutlined = createIcon('ant-design:inbox-outlined');

export const MinusOutlined = createIcon('ant-design:minus-outlined');

export const CopyOutlined = createIcon('ant-design:copy-outlined');
export const EyeOutlined = createIcon('ant-design:eye-outlined');
export const EyeInvisibleOutlined = createIcon('ant-design:eye-invisible-outlined');
